import { gql, useQuery } from '@apollo/client';
import { FlashSenderProgram } from '../../__generated__/queries-newsletter';

export const FLASH_SENDER_PROGRAMS = gql`
  query FlashSenderPrograms {
    flashSenderPrograms(first: 100, orderBy: createdAt_DESC) {
      id
      subject
      brandKey
      status
      scheduledAt
      teaser
    }
  }
`;

interface FlashSenderProgramsData {
  flashSenderPrograms: FlashSenderProgram[];
}

export const useFlashSenderPrograms = () =>
  useQuery<FlashSenderProgramsData>(FLASH_SENDER_PROGRAMS);

export const DELETE_FLASH_SENDER_PROGRAM = gql`
  mutation deleteFlashSenderProgram(
    $where: FlashSenderProgramWhereUniqueInput!
  ) {
    deleteFlashSenderProgram(where: $where) {
      id
    }
  }
`;
